module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "elements clearfix"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "top-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contact.stayInContact')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("\n                Bioseco S.A.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "adress",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('contact.street'))), _c('br'), _vm._v(" 80-298 Gdańsk"), _c('br'), _vm._v(" " + _vm._s(_vm.$t('contact.pl')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.haveQuestions')))])])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('router-link', {
    staticClass: "more-about-us",
    attrs: {
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])], 1)])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('p', [_vm._v("+48 603 422 633")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mail",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v("offers@bioseco.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_vm._v("\n                NIP 586-22-82-513"), _c('br'), _vm._v(" NIP EU PL5862282513"), _c('br'), _vm._v(" REGON 221871650"), _c('br'), _vm._v("KRS 0000906735"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "map",
    attrs: {
      "data-aos": "flip-left",
      "data-aos-delay": "250"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-hexagons"
  }, [_c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a61f8be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
// module id = 287
// module chunks = 0